import Vue from 'vue';
import {
  chatById, send, saveImg, saveVideo, storeReservation, templatesPush, read, templatesMulticastPush, invitationsPush, invitationsMulticastPush
} from '../../../services/backendService/chatService';
import {
  getSaId
} from '../../../services/personnelService/chatService';

 // initial state
 // state 必為模組區域變數，取時需 store.state.auth.user
 // 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
 // 區域使用時值需加上 name
const state = {
  datum: [],
  pagination: {
    current_page: 0,
    per_page: 5
  }
};

 // getters
 const getters = {};

 // actions
const actions = {
  // 取得對話紀錄
  async getChatHandler({ commit }, params) {
    const data = await chatById(params);
    commit('setDatum', data);
  },
  async sendHandler({}, data) {
    await send(data);
  },
  // 上傳圖片(拿到 Res 後在 Post Chat 送出)
  async saveImgHandler({}, formData) {
    const { data } = await saveImg(formData);
    return data;
  },
  // 上傳影片(拿到 Res 後在 Post Chat 送出)
  async saveVideoHandler({}, formData) {
    const { data } = await saveVideo(formData);
    return data;
  },
  // 建立預約
  async storeReservationHandler({}, storeInfo) {
    await storeReservation(storeInfo);
  },
  // 送出模板
  async templatesPushHandler({}, data) {
    await templatesPush(data);
  },
  async getSaIdHandler() {
    await getSaId();
  },
  async readHandler({}, member_uuid) {
    await read(member_uuid);
  },
  // 模板群發
  async templatesMulticastPushHandler({}, data) {
    await templatesMulticastPush(data);
  },
  // 送出邀請函
  async invitationsPushHandler({}, data) {
    await invitationsPush(data);
  },
  // 送出邀請函
  async invitationsMulticastPushHandler({}, data) {
    await invitationsMulticastPush(data);
  }
};

// mutations
const mutations = {
  setDatum(state, data) {
    Vue.set(state, 'datum', data.data.data);
    Vue.set(state, 'pagination', data.pagination);
  },
  // 重置所有資料
  resetHandler(state) {
    Vue.set(state, 'datum', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 5
    });
  }
};

 export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations
 };
